import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useState, useMemo, useEffect, useReducer } from 'react';
import { Observation } from '@mummssoftware/utils';
import { REFRESH_PN, REFRESH_ICON, ENTITY_PATIENT_CARE_PLAN_PROBLEM_TASK, ENTITY_MANIFEST } from './constants';
import { getPatientInitCountValues, getCrossPlatformInitCountValues } from './utils';
const initialState = {
  refresh: 0,
  refreshIcon: 0,
  refreshEntity: null,
  refreshEntityKey: null
};
const initPNCounterContext = {
  refresh: 0,
  refreshIcon: 0,
  refreshEntityKey: null
};
export const PNCounterContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    case REFRESH_PN:
      {
        const {
          refreshEntity,
          refreshEntityKey
        } = action.payload;
        newState.refresh += 1;
        newState.refreshEntity = refreshEntity;
        newState.refreshEntityKey = refreshEntityKey;
      }
      break;

    case REFRESH_ICON:
      newState.refreshIcon += 1;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const PNCounterContext = /*#__PURE__*/createContext(initPNCounterContext);
export const PNCounterDispatchContext = /*#__PURE__*/createContext({});
export const PNCounterContextConsumer = PNCounterContext.Consumer;
export const PNCounterDispatchContextConsumer = PNCounterDispatchContext.Consumer;
export const PNCounterContextProvider = ({
  children,
  keycloak,
  agency,
  patientNumber,
  entityTypes
}) => {
  const [{
    refresh,
    refreshIcon,
    refreshEntity,
    refreshEntityKey
  }, dispatch] = useReducer(PNCounterContextReducer, initialState);
  const initPatientCountValues = {};

  if (patientNumber) {
    const initCountValues = getPatientInitCountValues(entityTypes);
    initPatientCountValues[patientNumber] = initCountValues;
  } // State for our array of counts for *this* entityTypes


  const [countValues, setCountValues] = useState(initPatientCountValues); // Initialize the observation service, which contains the api calls for the counts

  const observationSvc = useMemo(() => !!keycloak && !!agency && new Observation({
    url: process.env.REACT_APP_OBSERVATION_URL,
    keycloak,
    agency
  }), [keycloak, agency]); // Make the call to update our array of counts

  const updateCounts = async (patientnumber, entitytype, doRefresh) => {
    observationSvc.getProgressNoteCountsByEntity(agency, entitytype, patientnumber).then(result => {
      if (!(result instanceof Response)) {
        countValues[patientnumber][entitytype] = result;
        setCountValues(countValues);

        if (doRefresh) {
          dispatch({
            type: REFRESH_ICON
          });
        }
      }
    });
  };

  const updateGlobalCount = async (entitytype, doRefresh) => {
    observationSvc.getProgressNoteCountsByEntity(agency, entitytype).then(result => {
      if (!(result instanceof Response)) {
        const crossPlatformCountValues = getCrossPlatformInitCountValues(result, countValues);
        setCountValues(crossPlatformCountValues);

        if (doRefresh) {
          dispatch({
            type: REFRESH_ICON
          });
        }
      }
    });
  }; // On Mount


  useEffect(() => {
    if (patientNumber && entityTypes && entityTypes.length) {
      entityTypes.forEach(async entity => updateCounts(patientNumber, entity));
    } else if (entityTypes && entityTypes.length) {
      const crossPlatformEntity = [ENTITY_MANIFEST, ENTITY_PATIENT_CARE_PLAN_PROBLEM_TASK];
      crossPlatformEntity.forEach(async entity => updateGlobalCount(entity));
    }
  }, []); // Update the patient counts whenever refresh.

  useEffect(() => {
    if (entityTypes && entityTypes.length && refreshEntity) {
      const doRefresh = true;

      if (patientNumber) {
        // does refresh Icon
        updateCounts(patientNumber, refreshEntity, doRefresh);
      } else {
        updateGlobalCount(refreshEntity, doRefresh);
      }
    }
  }, [refresh]); // Now wrap the children in the actual context provider.

  return /*#__PURE__*/React.createElement(PNCounterContext.Provider, {
    value: {
      countValues,
      updateCounts,
      refresh,
      refreshIcon,
      refreshEntityKey,
      dispatch
    }
  }, children);
};
export default PNCounterContext; // @note may be needed in the future
// export function withPNCounterContext(Component: any) {
//   return function contextComponent(props: any) {
//     return (
//       <PNCounterContextConsumer>
//         {(context) => (
//           <PNCounterDispatchContextConsumer>
//             {(dispatchContext) => (
//               <Component {...props} {...context} {...dispatchContext} />
//             )}
//           </PNCounterDispatchContextConsumer>
//         )}
//       </PNCounterContextConsumer>
//     );
//   };
// }